import { useEffect } from 'react'

interface useInitCarriersProps {
  getRows: Function
  setRows: Function
  setShowOverlay: Function
  handleToggleVisibility: Function
  handleSetDefaultSorting: Function
  currentCustomer: {} | null
  setRowActionsClickCount: Function
  rowActionsClickCount: number
}

const useInit = (props: useInitCarriersProps) => {
  useEffect(() => {
    props
      .getRows({
        setShowOverlay: props.setShowOverlay,
        handleToggleVisibility: props.handleToggleVisibility,
        handleSetDefaultSorting: props.handleSetDefaultSorting,
        setRowActionsClickCount: props.setRowActionsClickCount,
      })
      .then((data: any) => {
        props.setRows(data)
        props.setShowOverlay(false)
      })
  }, [props.currentCustomer, props.rowActionsClickCount])
}

export default useInit
